import '../../monitoring/filters/date/date_filter_view.js.coffee'

Namespace('Profiling.Dashboard.Filters')

class Profiling.Dashboard.Filters.DateFilterView extends Monitoring.Views.SocialContents.Filters.DateFilterView
  initialize: ({searchQuery, facet, title, filtersContainer, allowAllHistory}) ->
    super(searchQuery: searchQuery, facet: facet, filtersContainer: filtersContainer, allowAllHistory: allowAllHistory)
    @title = title || I18n.t('profiling.dashboard.fields.creation_date')

  _triggerQueryChanged: =>
    @searchQuery.triggerFilterChanged()
